export const IMPORT_ROUTE = 'IMP00000001';
export const IMPORT_CUSTOMER_INTO_ROUTE = 'IMP00000002';
export const IMPORT_PLANNING_HO = 'IMP00000003';
export const IMPORT_PLANNING_BRANCH = 'IMP00000004';
export const IMPORT_PLANNING_TEAM = 'IMP00000013';
export const IMPORT_CUSTOMER_INTO_SALES_TEAM = 'IMP00000006';
export const IMPORT_SALES_TEAM = 'IMP00000007';
export const IMPORT_USER_INTO_TEAM = 'IMP00000008';
export const IMPORT_CUSTOMER_INTO_PLANNING = 'IMP00000009';
export const IMPORT_SALES_PLANNING = 'IMP00000010';
export const IMPORT_SALES_TEAM_ROUTE = 'IMP00000011';
export const IMPORT_REWARD_CONDITION = 'IMP00000020';
export const IMPORT_REWARD_FRAME = 'IMP00000019';
export const IMPORT_GROUP_ROLE = 'IMP00000018';
export const IMPORT_REWARD_INFO = 'IMP00000017';
export const IMPORT_EDIT_REWARD_INFO = 'IMP00000019';
export const IMPORT_GROSS_PROFIT = 'IMP00000016';
export const IMPORT_REWARD_CALCULATION = 'IMP00000024';
export const IMPORT_HO_REVENUE = 'IMP00000012';
export const IMPORT_ROUTE_COST = 'IMP00000015';
export const IMPORT_EDIT_MANAGEMENT_GROUP = 'IMP00000021';
export const IMPORT_EDIT_EMPLOYEE = 'IMP00000022';
export const IMPORT_EDIT_FRAME = 'IMP00000023';
